module.exports = __webpack_public_path__ + "img/95ne.4922f26b.svg";